import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["bodyText", "submitButton", "errorMessage", "headerImage", "headerImageError"]

  connect() {
    this.validateBodyText()
  }

  // Meta rejects header images over 5MB when the template is sent, hours after
  // it was approved — so the file never leaves the browser if it is too large.
  validateHeaderImage() {
    const input = this.headerImageTarget
    const file = input.files[0]
    const maxBytes = Number(input.dataset.maxBytes)

    if (!file || file.size <= maxBytes) {
      this.headerImageErrorTarget.classList.add('hidden')
      return
    }

    const megabytes = (bytes) => (bytes / (1024 * 1024)).toFixed(1).replace('.', ',')
    this.headerImageErrorTarget.textContent =
      `Esta imagem tem ${megabytes(file.size)} MB. O WhatsApp aceita no máximo ` +
      `${maxBytes / (1024 * 1024)} MB — reduza a imagem (ou salve como JPEG) e envie novamente.`
    this.headerImageErrorTarget.classList.remove('hidden')
    input.value = ''
  }

  validateBodyText() {
    const textarea = this.bodyTextTarget
    const text = textarea.value
    const lines = text.split('\n')

    // Check if any line starts with {{ or ends with }} (possibly followed by punctuation only)
    const hasInvalidStart = lines.some(line => {
      const trimmed = line.trim()
      return trimmed.startsWith('{{')
    })

    const hasInvalidEnd = lines.some(line => {
      const trimmed = line.trim()
      // Ends with }} followed by optional punctuation marks only (., !, ?, ,, ;, :, etc.)
      // This regex matches }} at the end, optionally followed by punctuation and whitespace
      return /\}\}[.,!?;:\s]*$/.test(trimmed)
    })

    const hasError = hasInvalidStart || hasInvalidEnd

    if (hasError) {
      this.showError()
      this.disableSubmit()
    } else {
      this.hideError()
      this.enableSubmit()
    }
  }

  showError() {
    this.errorMessageTarget.classList.remove('hidden')
  }

  hideError() {
    this.errorMessageTarget.classList.add('hidden')
  }

  disableSubmit() {
    this.submitButtonTarget.disabled = true
    this.submitButtonTarget.classList.add('opacity-50', 'cursor-not-allowed')
  }

  enableSubmit() {
    this.submitButtonTarget.disabled = false
    this.submitButtonTarget.classList.remove('opacity-50', 'cursor-not-allowed')
  }

  normalizeName() {
    const nameField = this.element.querySelector('[name="whatsapp_template[name]"]')
    const displayNameField = this.element.querySelector('[name="whatsapp_template[display_name]"]')
    displayNameField.value = displayNameField.value || nameField.value
    nameField.value = nameField.value.toLowerCase().replace(/[^a-z0-9]+/g, '_').replace(/^_+|_+$/, '')
  }
}
